import { useStoreLogger } from '@/logger.ts'
import type { IConsultantLocatorNameRequest, IConsultantLocatorKnowAllRequest, IConsultantLocatorZipCodeRequest, IConsultantLocatorResponse } from '@/types/LocatorTypes'
import { GetLocatorConsultantList, GetLocatorConsultantKnowAllList, GetLocatorConsultantListByZip } from '@/api/Locator'


export async function GetLocatorConsultants(
  request: IConsultantLocatorNameRequest
): Promise<IConsultantLocatorResponse> {
  const logger = useStoreLogger()
  logger.debug('GetLocatorConsultants', request)
  const locatorList = await GetLocatorConsultantList(request)
  return locatorList
}

export async function GetLocatorConsultantsByZip(
  request: IConsultantLocatorZipCodeRequest
): Promise<IConsultantLocatorResponse> {
  const logger = useStoreLogger()
  logger.debug('GetLocatorConsultants', request)
  const locatorList = await GetLocatorConsultantListByZip(request)
  return locatorList
}

export async function GetLocatorConsultantsKnowAll(
  request: IConsultantLocatorKnowAllRequest
): Promise<IConsultantLocatorResponse> {
  const logger = useStoreLogger()
  logger.debug('GetLocatorConsultantsKnowAll', request)
  const locatorList = await GetLocatorConsultantKnowAllList(request)
  return locatorList
}
